import { MicrosoftTeamsIcon } from "#components/ui/MicrosoftTeamsIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const teamsManifest: IntegrationManifest = {
    key: "teams",
    displayName: "Microsoft Teams",
    nameKey: "channels.teams",
    descriptionKey: "teamsDescription",
    trayDescriptionKey: "composerTrayDescriptions.teams",
    cardDescriptionKey: "connectIntegration.descriptions.teams",
    connectedContentKeys: ["teamsChannels", "teamsChats"],
    brandColor: "#6264A7",
    iconUrl: IconAssets.Teams,
    iconUrlAlt: IconAssets.TeamsAlt,
    glyph: MicrosoftTeamsIcon,
    channelType: "UserTeams",
    dataSources: ["teams_message"]
};
